const DIET_NODE_TYPES = { DIET: 'DIET', DIET_CATEGORY: 'DIET_CATEGORY' }

export default DIET_NODE_TYPES
